<template>
  <div id="dialog-wheelDateChooser">
    <span class="cls" @click="cancel()"></span>
    <div class="dialog">
      <h2>날짜 선택</h2>
      <div class="content">
        <!-- 연도 피커 -->
        <VueScrollPicker
          :options="yearOptions"
          v-model="selectedYear"
          :empty-text="'연도가 없습니다'"
          :wheel-sensitivity="1.2"
          @update:modelValue="onUpdate('year', $event)"
        />

        <!-- 월 피커 -->
        <VueScrollPicker
          :options="monthOptions"
          v-model="selectedMonth"
          :empty-text="'월이 없습니다'"
          :wheel-sensitivity="1.2"
          @update:modelValue="onUpdate('month', $event)"
        />

        <!-- 일 피커 -->
        <VueScrollPicker
          :options="dayOptions"
          v-model="selectedDay"
          :empty-text="'일이 없습니다'"
          :wheel-sensitivity="1.2"
          @update:modelValue="onUpdate('day', $event)"
        />

      </div>
      <button @click="submitDate">확인</button>
    </div>
  </div>
</template>


<script>
import { ref } from "vue"
import { VueScrollPicker } from 'vue-scroll-picker'
import 'vue-scroll-picker/style.css'

export default {
  props: {
    defaultDate: String // 예: '2024-07-30'
  },
  components: { VueScrollPicker },
  emits: ['submit'],
  setup(props, { emit }) {
    const currentYear = new Date().getFullYear()
    const currentMonth = new Date().getMonth() + 1
    const currentDay = new Date().getDate()

    // defaultDate 안전하게 분해
    const dateParts = props.defaultDate?.split('-') || []
    const defaultYear = Number(dateParts[0]) || currentYear
    const defaultMonth = Number(dateParts[1]) || currentMonth
    const defaultDay = Number(dateParts[2]) || currentDay

    const yearOptions = Array.from({ length: 100 }, (_, i) => {
      const y = currentYear - i
      return { name: `${y}년`, value: y }
    })
    const monthOptions = Array.from({ length: 12 }, (_, i) => ({ name: `${i + 1}월`, value: i + 1 }))
    const dayOptions = Array.from({ length: 31 }, (_, i) => ({ name: `${i + 1}일`, value: i + 1 }))

    const selectedYear = ref(defaultYear)
    const selectedMonth = ref(defaultMonth)
    const selectedDay = ref(defaultDay)

    function submitDate() {
      emit('submit', {
        year: selectedYear.value,
        month: selectedMonth.value,
        day: selectedDay.value
      })
    }

    function cancel() {
      emit('submit', {
        year: defaultYear,
        month: defaultMonth,
        day: defaultDay
      })
    }

    function onUpdate(type, value) {
      console.log(`${type} 선택됨:`, value)
    }

    return {
      yearOptions, monthOptions, dayOptions,
      selectedYear, selectedMonth, selectedDay,
      submitDate,
      cancel,
      onUpdate
    }
  }
}
</script>


<style scoped>
#dialog-wheelDateChooser {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
}

.cls {
  position: absolute;
  width:100%;
  height:100%;
  cursor: pointer;
  z-index: -1;
}

#dialog-wheelDateChooser > .dialog {
  left: var(--font-size-lg);
  top: var(--font-size-7xl);
  width: 400px;
  height: auto;
  padding: 24px;
  box-sizing: border-box;
  background: var(--color-background);
  backdrop-filter: blur(var(--effect-blur));
  color:var(--color-text-primary);
  border-radius: 24px;
  max-height: 70vh;
  overflow:scroll;
  scrollbar-width: none;
  border:1px solid var(--color-text-primary);
}

.dialog h2 {
  font-size: var(--font-size-lg);
  text-align: center;
  width:100%;
  padding:0;
  margin:0;
}

.dialog > .content {
  display: flex;
  flex-direction: row;
  gap: 16px;
}

.dialog > button {
  width:100%;
  height:36px;
  background-color: var(--color-brand);
  color: var(--color-text-secondary);
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

</style>

<style>
.vue-scroll-picker-item {
  color:var(--color-text-primary);
  opacity: 0.8;
  font-size:20px;
}
.vue-scroll-picker-item[aria-selected=true] {
  color: var(--color-brand);
  opacity: 1;
}
@media (prefers-color-scheme: dark) {
  .vue-scroll-picker-layer-bottom{
    background: linear-gradient(0deg, #000 10%, rgba(0, 0, 0, .7)) !important;
  }
  .vue-scroll-picker-layer-top {
    background: linear-gradient(180deg, #000 10%, rgba(0, 0, 0, .7)) !important;
  }
}

@media (prefers-color-scheme: light) {
  .vue-scroll-picker-layer-bottom {
    background: linear-gradient(0deg, #fff 10%, rgba(255, 255, 255, .7)) !important;
  }
  .vue-scroll-picker-layer-top {
    background: linear-gradient(180deg, #fff 10%, rgba(255, 255, 255, .7)) !important;
  }
}
</style>
